import { GlobalCable } from "@/commons/interface/lib-device/global-cable";
import { StdResponse, bimAxios } from "@/config/axios";


export function getGlobalCableDetail(id: number, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.get(`/global-cables/${id}`, {
        params: {
            ...params,
        }
    })
}

export function createGlobalCable(data: GlobalCable, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.post(`/global-cables`, data, {
        params: {
            ...params,
        }
    })
}

export function updateGlobalCable(id: number, data: GlobalCable, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.put(`/global-cables/${id}`, data, {
        params: {
            ...params,
        }
    })
}

export function deleteGlobalCable(id: number, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.delete(`/global-cables/${id}`, {
        params: {
            ...params,
        }
    })
}

export function getGlobalCables(params?: {}): Promise<StdResponse<any>> {
    return bimAxios.get(`/global-cables`, {
        params: {
            ...params,
        }
    })
}